import { call, put, putResolve, takeEvery } from 'typed-redux-saga';

import { dictionaryAPI } from '@/api';
import * as global from '@/model/global/actions';
import { withGlobalLock } from '@/model/global/utils';
import { takeEveryTypesafe } from '@/utils/redux';

import * as actions from './actions';

function* init(): Generator {
  try {
    let state: actions.StoreInitActionPayload = { banks: [] };

    try {
      state = {
        ...state,
        banks: yield* call(dictionaryAPI.queryBanks),
      };
    } catch (e) {
      // do nothing
    }
    yield* putResolve(actions.storeInitialized(state).pure);
  } finally {
    yield put(actions.notifyInitializationFinished().pure);
  }
}

function* logout(): Generator {
  yield* put(actions.storeLogout().pure);
}

export default function* rootSaga(): Generator {
  yield* takeEveryTypesafe(actions.init, withGlobalLock(init, 'common.messages.operations.init'));
  yield* takeEvery(global.notifyLogout.type, withGlobalLock(logout, 'common.messages.operations.logout'));
}
